module.exports = __webpack_public_path__ + "img/product_cpyt_lct.1cdccfae.png";